import { render, staticRenderFns } from "./marketing-report-list.vue?vue&type=template&id=1a58257e&scoped=true&"
import script from "./marketing-report-list.vue?vue&type=script&lang=js&"
export * from "./marketing-report-list.vue?vue&type=script&lang=js&"
import style0 from "./marketing-report-list.vue?vue&type=style&index=0&id=1a58257e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58257e",
  null
  
)

export default component.exports